/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.modals.membership.controllers', [])

.controller('MembershipModalController', ['$scope', '$uibModalInstance', '$sce', 'modalDetails', function($scope, $uibModalInstance, $sce, modalDetails) {

    $scope.membershipModal = {

      title: 'Membership Details',
      saveText: 'OK',
      details: modalDetails,

      init: function() {},

      close: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $uibModalInstance.close('success');
      }

    };

    $scope.membershipModal.init();

}]);